<template>
    <div>
        <el-input v-bind:value="value" ref="input" v-on:input="updateValue()"
               :placeholder="placeholder"
               ></el-input>
               
        <div class="bs-example bs-example-bg-classes" style="color:red"
             v-bind:class="{ show: isCheck }">{{error}}</div>
    </div>
</template>

<script>
var isType = false;
export default {
    props: ['placeholder', 'error','value', 'j', 'isCheck'],
    data() {
        return {
            currentValue : Object,
        }
    },
    methods: {
         updateValue () {
            var self = this;
            if(!isType){
                isType =true;
            setTimeout(function() {
                isType =false;
                  self.currentValue = self.$refs.input.currentValue;
                  self.$emit('input',self.currentValue)
                  console.log(self.currentValue)
            }, 300);
            }
         }
    }
}

</script>





// WEBPACK FOOTER //
// input.vue?15572560